export enum DataPropertyType {
    Product = "GP",
    Sales = "SP"
}